import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  List,
  ListItem,
  ListItemText,
  Alert,
  Divider,
  Box,
  Button,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import InfoIcon from "@mui/icons-material/Info";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

const InstructionsBox = styled(Paper)(({ theme }) => ({
    borderLeft: `6px solid #1976d2`,
    backgroundColor: theme.palette.background.default,
  }));
  
  const HighlightText = styled('span')(({ theme }) => ({
    color: "#d32f2f",
    fontWeight: 'bold',
  }));

  const FileNameExample = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing(1, 0, 1, 2),
  }));

  const CorrectIcon = styled(CheckCircleIcon)(({ theme }) => ({
    color: theme.palette.success.main,
    marginLeft: theme.spacing(1),
  }));
  
  const IncorrectIcon = styled(CancelIcon)(({ theme }) => ({
    color: theme.palette.error.main,
    marginLeft: theme.spacing(1),
  }));

  const sampleData = [
    { name: 'Demo1', mobile: '6000000001', grade: '9TH STD', state: 'KARNATAKA', city: 'BANGALORE URBAN', branch: 'BLR-NLM-BOYS-NJC' }
  ];

export const CSVInstructions = () => {
  return (
    <Box >
      <Paper sx={{padding:"20px"}}>
        <Box>
          <InstructionsBox elevation={1}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 1,paddingLeft:"5px" }}>
              <InfoIcon color="primary" sx={{ mr: 1 }} />
              <Typography variant="h6" component="h3">
                CSV Upload Instructions
              </Typography>
            </Box>
            <List dense>
              <ListItem>
                <ListItemText
                  primary={
                    <>
                      <HighlightText>Maximum 50 records</HighlightText> can be
                      uploaded in a single CSV file
                    </>
                  }
                />
              </ListItem>
              <ListItem>
                <ListItemText primary="The CSV file must contain the following columns: Name, Mobile, Grade, State, City, Branch" />
              </ListItem>
              <ListItem>
                <ListItemText primary="All fields are required for each record" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Mobile numbers should be valid 10-digit numbers" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Only CSV format is supported" />
              </ListItem>
              <ListItem>
            <ListItemText 
              primary={<>CSV file name should not contain spaces as it will throw an error</>}
              secondary={
                <Box sx={{ mt: 1 }}>
                  <FileNameExample>
                    <Typography variant="body2">student_records.csv</Typography>
                    <CorrectIcon fontSize="small" />
                  </FileNameExample>
                  <FileNameExample>
                    <Typography variant="body2">student records.csv</Typography>
                    <IncorrectIcon fontSize="small" />
                  </FileNameExample>
                </Box>
              }
            />
          </ListItem>
            </List>
          </InstructionsBox>

          {/* Sample Format Section */}
          <Typography variant="h6" component="h3" sx={{margin:"30px 0px 20px 20px"}}>
            Sample Format
          </Typography>
          <TableContainer component={Paper} sx={{ mb: 3 }}>
            <Table aria-label="sample format table">
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Mobile</TableCell>
                  <TableCell>Grade</TableCell>
                  <TableCell>State</TableCell>
                  <TableCell>City</TableCell>
                  <TableCell>Branch</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sampleData.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{row.name}</TableCell>
                    <TableCell>{row.mobile}</TableCell>
                    <TableCell>{row.grade}</TableCell>
                    <TableCell>{row.state}</TableCell>
                    <TableCell>{row.city}</TableCell>
                    <TableCell>{row.branch}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Note Section */}
          <Alert severity="warning" sx={{ mb: 3 }}>
            <Typography variant="body2">
              Please ensure your data follows the exact format shown in the
              sample above.
            </Typography>
          </Alert>
        </Box>
      </Paper>
    </Box>
  );
};
